import { OnboardingHub } from './OnboardingHub';

export function OnboardingHubPage(): JSX.Element {
  return <OnboardingHub />;
}
